import styled from 'styled-components';

export const InputDiv = styled.div`
  height: fit-content;
  position: relative;
`;

export const Label = styled.label<{ disabled?: boolean }>`
  font-size: 14px;
  font-weight: 700;
  display: block;
  margin-bottom: 0.5rem;
  color: ${(props) => (props.disabled ? '#7A7A7A' : '#333')};
`;

export const Input = styled.input<{ $hasError?: boolean }>`
  width: 100%;
  height: 40px;
  padding: 10px 16px;
  background-color: #ebebeb;
  border: 1px solid transparent;
  border-radius: 20px;
  color: #696969;
  font-family: 'Inter', sans-serif;
  outline: none;
  cursor: text;
  box-shadow: none;

  ${({ $hasError }) =>
    $hasError &&
    `
    border: 1.5px solid #f87171 !important;
    box-shadow: 0 0 3px #f87171 !important;
  `}

  &:focus,
  &:focus-visible,
  &:active {
    border-color: transparent;
    box-shadow: none;
    outline: none;
  }

  &:disabled {
    background-color: #d3d3d3;
    cursor: default;
  }

  &::placeholder {
    color: #696969;
    font-style: italic;
  }
`;

export const SearchOptions = styled.ul`
  position: absolute;
  list-style: none;
  z-index: 9100;
  width: 100%;
  top: 4.5rem;
  border-radius: 1rem;
  border: 1px solid #ebebeb;
  overflow-x: hidden;
  max-height: 10rem;
  overflow-y: auto;
  background-color: #fff;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`;

export const Option = styled.li<{ isSelected?: boolean }>`
  cursor: pointer;
  padding: 0.8rem 1rem;
  background-color: ${(props) => (props.isSelected ? '#f4f4f4' : '#fff')};
  border-bottom: 1px solid #ebebeb;
  user-select: none;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  span {
    display: block;
  }

  &:hover {
    background-color: #f4f4f4;
  }
`;
